<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading
        :active.sync="isLoading"
        loader="spinner"
        color="#36304a"
        :width="70"
      ></loading> -->
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar
          class="formCard"
          style="
            border-radius: 5px !important;
            padding-left: 0px;
            height: auto !important;
          "
          toggleable="lg"
          type="dark"
          variant="primary"
        >
          <b-navbar-nav>
            <b-button
              class="mobile-btn"
              @click="previousSalesView"
              size="sm"
              variant="light"
            >
              <md-icon icon="gear-fill" aria-hidden="true">skip_previous</md-icon>Back
            </b-button>
          </b-navbar-nav>
          <b-navbar-brand class="mobile-font" center
            >All Deleted Request Assignment Details</b-navbar-brand
          >
        </b-navbar>

        <b-card class="formCard">
          <b-card-text>
            <div class="mt-3">
              <!-- Search Form Input Start-->
              <b-row>
                <b-col md="10" class="my-1">
                  <b-form-group>
                    <b-input-group>
                      <b-form-input
                        :formatter="capitalizeAll"
                        @input="debounceSearch"
                        v-model="filter"
                        placeholder="Type To Search  (Assignment No. / Client / Container No./SB No. Shipper Inv No.)"
                      />
                      <b-input-group-append>
                        <b-button :disabled="!filter" @click="filterClear"
                          >Clear</b-button
                        >
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </b-col>
                <b-col md="2">
                  <h5 class="text-muted pull-right mt-2 ml-3">
                    <small v-if="isLoading == false">{{ totalRows }} Entries</small>
                  </h5>
                  <b-button
                    class="pull-right"
                    v-if="Total_Delete_RequestList.length > 0"
                    @click="getReports('All_Sales_Execution_Delete_List')"
                    size="sm"
                    variant="warning"
                    >Export as Excel</b-button
                  >
                </b-col>
              </b-row>
              <!-- Search Form Input End-->
              <!-- Main table element -->
              <div class="table-responsive tableMain">
                <b-table
                  show-empty
                  stacked="md"
                  :items="Total_Delete_RequestList"
                  :fields="fields"
                  :current-page="currentPage"
                  :per-page="perPage"
                  :filter="filter"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  :sort-direction="sortDirection"
                  @filtered="onFiltered"
                >
                  <template slot="jobType" slot-scope="row0">
                    <span>{{ row0.index + 1 + (currentPage - 1) * perPage }}</span>
                  </template>
                  <template slot="mainSalesSeries" slot-scope="row1">
                    <md-icon>{{
                      row1.item.shipmentType == "1" ||
                      row1.item.shipmentType == "Sea_Shipment"
                        ? "directions_boat"
                        : "flight_takeoff"
                    }}</md-icon>
                    <b
                      class="showMoreData"
                      :disabled="row1.item.asignDeleted == '1'"
                      @click="
                        viewExportFCLConPage(row1.item.allModuleId, row1.item.isMiscJob)
                      "
                      >{{ row1.item.mainSalesSeries }}</b
                    >
                    <br />
                    <span>Assignment Dt. : {{ row1.item.loginTime | moment }}</span>
                    <br />
                    <span
                      >Job Type : {{ row1.item.jobType }} ({{
                        row1.item.shipmentType == "1" ||
                        row1.item.shipmentType == "Sea_Shipment"
                          ? "Sea"
                          : "Air"
                      }}
                      {{ row1.item.transportType }})
                    </span>
                    <br />

                    <span>Raised From : {{ row1.item.baseLoc }}</span
                    ><br />
                    <span> By : {{ row1.item.raisedBy }}</span
                    ><br />

                    <b-button
                      size="sm"
                      class="mt-2"
                      style="font-size: 0.675rem"
                      @click="showDocModal(row1.item)"
                      variant="outline-info"
                      >Summary & Documents</b-button
                    >
                    <InvExpSummary
                      v-if="row1.item.allModuleId"
                      :PMC_title="'Inv Exp Summary Job No - ' + row1.item.mainSalesSeries"
                      :PMC_JOBID="row1.item.allModuleId"
                      :PMC_JOBNO="row1.item.mainSalesSeries"
                      :PMC_JOBDATE="row1.item.loginTime | moment"
                      :PMC_JOBTYPE="row1.item.jobType"
                      :PMC_AgentType="''"
                      :PMC_Client="row1.item.TPTClient"
                      :PMC_Sline="row1.item.shippingLine"
                    />
                    <ContainerSummary
                      v-if="row1.item.allModuleId"
                      :PMC_title="
                        'Container Summary Job No - ' + row1.item.mainSalesSeries
                      "
                      :PMC_JOBID="row1.item.allModuleId"
                      :PMC_JOBNO="row1.item.mainSalesSeries"
                      :PMC_JOBDATE="row1.item.loginTime | moment"
                      :PMC_JOBTYPE="row1.item.jobType"
                      :PMC_AgentType="''"
                      :PMC_Client="row1.item.TPTClient"
                      :PMC_Sline="row1.item.shippingLine"
                    />
                    <RejectInvTallyBillSummary
                      v-if="row1.item.allModuleId"
                      :PMC_title="
                        'Invoice Rejection Log Summary Job No - ' +
                        row1.item.mainSalesSeries
                      "
                      :PMC_JOBID="row1.item.allModuleId"
                      :PMC_JOBNO="row1.item.mainSalesSeries"
                      :PMC_JOBDATE="row1.item.loginTime | moment"
                      :PMC_JOBTYPE="row1.item.jobType"
                      :PMC_Client="row1.item.TPTClient"
                      :PMC_Sline="row1.item.shippingLine"
                    />
                    <JobWisePaymentsDetails
                  v-if="row1.item.allModuleId"
                  :allModuleId="Number(row1.item.allModuleId)"
                  :JobNo="row1.item.mainSalesSeries"
                  />
                    <br />
                    <h7 class="mt-2" v-if="row1.item.splitFromId != '0'"
                      ><b-badge variant="info"
                        >Split of {{ row1.item.splitFromNo }}</b-badge
                      >
                    </h7>

                    <h6>
                      <b-badge variant="danger" v-if="row1.item.asignDeleted == '1'"
                        >Assignment Deleted</b-badge
                      >
                    </h6>
                  </template>
                  <template slot="TPTClient" slot-scope="row11">
                    <b
                      v-if="
                        row11.item.clientType == '3' &&
                        row11.item.transportType == 'Export'
                      "
                    >
                      Client Name : {{ row11.item.exporter }}
                      <br />
                    </b>
                    <b v-if="row11.item.clientType == '3'">
                      Overseas Agent : {{ row11.item.TPTClient }}
                      <br />
                    </b>
                    <b v-if="row11.item.clientType != '3'">
                      {{ row11.item.TPTClient }}
                      <br />
                    </b>
                  </template>
                  <template
                    v-if="row2.item.EnqJob"
                    slot="mainEnquirySeries"
                    slot-scope="row2"
                  >
                    <span>{{ row2.item.mainEnquirySeries }}</span>
                    <br />
                    <span
                      >Enquiry Type : {{ row2.item.EnqJob }} ({{
                        row2.item.shipmentType == "1" ? "Sea" : "Air"
                      }}
                      {{ row2.item.transportType }})</span
                    >
                    <br />
                    <span>Enquiry Date : {{ row2.item.enqDate | moment }}</span>
                  </template>
                  <template slot="POR" slot-scope="row7">
                    <div v-if="row7.item.shipmentType == '1'">
                      <span>Container Type : {{ row7.item.multipleContainerType }}</span>
                      <br />
                      <span>No of Containers : {{ row7.item.multiConNo }}</span>
                      <br />

                      <span
                        v-if="
                          row7.item.newContainerFlow == '1' &&
                          row7.item.shipmentType == '1' &&
                          parseInt(row7.item.multiConNo) !=
                            parseInt(row7.item.amendmentContainersCount)
                        "
                        class="error"
                        ><b
                          >Amendment Containers:
                          {{ row7.item.amendmentContainersCount }}</b
                        ><br
                      /></span>
                      <span>Shipping Line : {{ row7.item.shippingLine }}</span>
                      <br />
                      <span>Pickup : {{ row7.item.pickup }}</span>
                      <br />
                      <span>Stuffing : {{ row7.item.stuffingLoc }}</span>
                      <br />
                      <span>Handover : {{ row7.item.handover }}</span>
                      <br />
                      <span>Place of Receipt : {{ row7.item.POR }}</span>
                      <br />
                      <div v-if="row7.item.jobType.split(',').includes('FF')">
                        <span>Load Port : {{ row7.item.LP }}</span>
                        <br />
                        <span>Port of Discharge : {{ row7.item.POD }}</span>
                        <br />
                        <span>Final Place of Delivery : {{ row7.item.finalPlace }}</span>
                      </div>
                    </div>
                    <div v-else>
                      <span>
                        Departure Airport : {{ row7.item.AirDept }}
                        <br />
                      </span>
                      <span>
                        Destination Airport : {{ row7.item.airDesti }}
                        <br />
                      </span>
                      <span>
                        No.of Packages : {{ row7.item.noOfPkg }}
                        <br />
                      </span>
                      <span>
                        Cargo Received At :
                        {{ row7.item.cargoReceived == "1" ? "Airport" : "Warehouse" }}
                        <br />
                      </span>
                    </div>
                  </template>

                  <template slot="Payment_Status" slot-scope="row11">
                    <!-- {{row11.item}} -->
                    {{ row11.item.Payment_Status }}<br />
                    <b-badge
                      variant="success"
                      v-if="row11.item.subscription_status == 'Subscribed'"
                      ><b>{{ row11.item.subscription_status }}</b></b-badge
                    >
                    <b-badge variant="danger" v-else
                      ><b>{{ row11.item.subscription_status }}</b></b-badge
                    >
                  </template>
                  <template slot="deleteRequest" slot-scope="row10">
                    <td>
                      <b
                        style="color: red"
                        v-if="row10.item.deleteRequest == '0'"
                        class="showMoreData"
                        @click="
                          execActions(
                            row10.item.allModuleId,
                            '1',
                            row10.item.mainSalesSeries
                          )
                        "
                        >Request To Delete Assignment</b
                      >
                      <br v-if="row10.item.deleteRequest == '0'" />
                      <b
                        style="color: red"
                        v-if="
                          row10.item.deleteRequest == '1' &&
                          row10.item.ApproveRejectDelReq == '0' &&
                          ($sessionsStorage.get('designation') == 'manager' ||
                            $sessionsStorage.get('designation') == 'employee')
                        "
                        >Sent For Delete Approval</b
                      >

                      <br
                        v-if="
                          row10.item.deleteRequest == '1' &&
                          row10.item.ApproveRejectDelReq == '0' &&
                          ($sessionsStorage.get('designation') == 'manager' ||
                            $sessionsStorage.get('designation') == 'employee')
                        "
                      />
                      <b
                        @click="
                          execActions(
                            row10.item.allModuleId,
                            '2',
                            row10.item.mainSalesSeries
                          )
                        "
                        style="color: red"
                        v-if="
                          row10.item.deleteRequest == '1' &&
                          row10.item.ApproveRejectDelReq != '2' &&
                          ($sessionsStorage.get('designation') == 'Admin' ||
                            $sessionsStorage.get('designation') == 'HOD')
                        "
                        class="showMoreData"
                        >Approve Delete Request /</b
                      >
                      <b
                        @click="
                          execActions(
                            row10.item.allModuleId,
                            '3',
                            row10.item.mainSalesSeries
                          )
                        "
                        style="color: red"
                        v-if="
                          row10.item.deleteRequest == '1' &&
                          row10.item.ApproveRejectDelReq != '2'
                        "
                        class="showMoreData"
                        >Reject Delete Request</b
                      >
                      <br
                        v-if="
                          row10.item.deleteRequest == '0' &&
                          row10.item.ApproveRejectDelReq != '2'
                        "
                      />
                      <b
                        @click="
                          execActions(
                            row10.item.allModuleId,
                            '4',
                            row10.item.mainSalesSeries
                          )
                        "
                        style="color: red"
                        v-if="
                          row10.item.ApproveRejectDelReq == '2' &&
                          row10.item.asignDeleted != '1'
                        "
                        class="showMoreData"
                        >Delete Assignment</b
                      >
                      <br />

                      <b
                        v-if="
                          row10.item.deleteRequestBy != '' &&
                          row10.item.deleteRequestBy != '0'
                        "
                        >Requested By : {{ row10.item.deleteRequestBy }}</b
                      ><br />
                      <span
                        v-if="
                          row10.item.invoiceNoCreated != '' &&
                          row10.item.invoiceNoCreated != null &&
                          row10.item.invoiceNoCreated != undefined
                        "
                      >
                        Invoice : {{ row10.item.invoiceNoCreated }}<br />
                      </span>
                      <span
                        v-if="
                          row10.item.GRDetails != '' &&
                          row10.item.GRDetails != null &&
                          row10.item.GRDetails != undefined
                        "
                      >
                        GR Details : {{ row10.item.GRDetails }}<br />
                      </span>

                      <span
                        v-if="
                          row10.item.InvoiceDetails != '' &&
                          row10.item.InvoiceDetails != null &&
                          row10.item.InvoiceDetails != undefined
                        "
                      >
                        Invoice Details : {{ row10.item.InvoiceDetails }}
                      </span>
                    </td>
                  </template>
                </b-table>
              </div>
              <b-row>
                <b-col md="12" class="my-1">
                  <b-pagination
                    limit="25"
                    :total-rows="totalRows"
                    :per-page="perPage"
                    v-model="currentPage"
                    class="my-0 pull-right"
                  />
                </b-col>
              </b-row>
            </div>
          </b-card-text>
        </b-card>
      </b-card-text>
    </b-card>
    <div>
      <b-modal
        class="modal-dialog-doc"
        size="xl"
        no-close-on-esc
        no-close-on-backdrop
        ref="doc-modal"
        hide-footer
        title="Using Component Methods"
      >
        <div v-if="ALLMODULE">
          <doc-form :allModuleIdProp="ALLMODULE" :JOBSERIES="JOBSERIES" />
        </div>
        <b-button class="mt-3" variant="outline-danger" block @click="hideDocModal"
          >Close
        </b-button>
      </b-modal>
    </div>
    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      @close="onCloseAction"
      ref="addPopMail"
    ></md-dialog-confirm>
    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      @close="onCloseAction"
      ref="addPopApprove"
    ></md-dialog-confirm>
    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      @close="onCloseAction"
      ref="addPopReject"
    ></md-dialog-confirm>
    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      @close="onCloseAction"
      ref="addPopDelete"
    ></md-dialog-confirm>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import DatePicker from "vue2-datepicker";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import { ModelListSelect } from "vue-search-select";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import {
  lastVisitPage,
  globalPermissionStatus,
  GlobalGetLocation,
} from "../../helper/collection";
import DocForm from "./docLibrary.vue";

import InvExpSummary from "../common/moduleBasedInvExpSummary.vue";
import ContainerSummary from "../common/moduleBasedContaierSummary.vue";
import JobWisePaymentsDetails from "../common/jobWisePaymentsDetails.vue";
import RejectInvTallyBillSummary from "../common/moduleBasedRejectInvTallyBillSummary.vue";

export default {
  beforeMount() {
    lastVisitPage(this.$router.history.current.fullPath);
    if (globalPermissionStatus("Enquiry & Pricing")) {
      this.$store.dispatch("setCurrentRoute", "/ffExportCon/viewConsoBooking");
      if (this.lastVisitPage && this.$sessionsStorage.get("lastVisitPage")) {
        this.fetchLastPage(this.lastVisitPage);
      } else {
        this.getData("0", "0", "1", "1");
      }
    } else {
      this.$router.push({
        path: "/dashboard",
      });
    }
  },
  data() {
    return {
      filtrActive: 0,
      routePageId: "",
      lastVisitPage: this.$sessionsStorage.get("lastVisitPage"),

      ALLMODULE: "",
      JOBSERIES: "",
      reload: true,
      clientMaster: [],
      totalRows: 1000000000000000,
      currentPage: 1,
      perPage: 10,
      pageOptions: [20, 50, 100],
      sortBy: null,
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      fields: [
        {
          key: "jobType",
          mainkey: "jobType",
          label: "SN.",
          sortable: true,
          sortDirection: "ASC",
        },
        {
          key: "mainSalesSeries",
          mainkey: "mainSalesSeries",
          label: "Assignment No.",
          sortable: true,
          sortDirection: "ASC",
          table: "A.",
        },
        {
          key: "TPTClient",
          mainkey: "clientName",
          label: "Client / Shipper Name",
          sortable: true,
          sortDirection: "ASC",
          table: "K.",
        },
        {
          key: "mainEnquirySeries",
          mainkey: "mainEnquirySeries",
          label: "Enquiry No.",
          sortable: true,
          sortDirection: "ASC",
          table: "Z.",
        },
        {
          key: "POR",
          mainkey: "POR",
          label: "Assignment Details",
          sortable: true,
          sortDirection: "ASC",
        },
        {
          key: "Payment_Status",
          mainkey: "Payment_Status",
          label: "Payment Status",
          sortable: true,
          sortDirection: "ASC",
        },
        {
          key: "deleteRequest",
          mainkey: "deleteRequest",
          label: "Action",
          sortable: true,
          sortDirection: "ASC",
          class: "text-center",
        },
      ],
      dateSearch: {
        fromDate: "",
        toDate: "",
      },
      eventId: "",
      mailallModuleId: "",
      mailExecSeries: "",
      isLoading: false,
      visible: false,
      alert: {
        content: "Are you sure you want to delete ..!",
        ok: "ok",
      },
      fixed: true,
      Total_Delete_RequestList: [],
      validate: true,
    };
  },
  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },
  mounted() {},

  beforeDestroy() {},

  destroyed() {},

  components: {
    // Loading,
    CustomLoader,
    DatePicker,
    ModelListSelect,
    DocForm,
    ContainerSummary,
    RejectInvTallyBillSummary,
    InvExpSummary,
    JobWisePaymentsDetails,
  },

  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => {
          return { text: f.label, value: f.key };
        });
    },
  },
  methods: {
    getReports(id) {
      var excelId = "All_Sales_Execution_Delete_List";

      if (id == "All_Sales_Execution_Delete_List") {
        excelId = "All_Sales_Execution_Delete_List";
      }

      let view_Assignment = {
        excelId: excelId,
      };

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Reports/reportsExcel_NewV3.php`,
        data: JSON.stringify(view_Assignment),
        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };

      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            window.location.href =
              `https://uploadsp.pridel.com/Pridel_Reports/` + data.excelName;
          }
        })
        .catch((error) => {});
    },
    doLoading() {
      this.isLoading = true;
    },
    doLoadingClose() {
      this.isLoading = true;
      setTimeout(() => {
        this.isLoading = false;
      }, 500);
    },
    previousSalesView() {
      window.history.go(-1);
    },
    debounceSearch(event) {
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        this.getData("0", "0", "1", "1");
      }, 1000);
    },
    filterClear() {
      this.filter = "";
      this.getData("0", "0", "1", "1");
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    JqueryFun() {
      return $(function () {
        return $("#portLocationNew").DataTable();
      });
    },

    execActions(allModuleId, id, series) {
      this.mailallModuleId = allModuleId;
      this.eventId = id;
      this.mailExecSeries = series;

      if (id == "1") {
        this.alert.content = "Send Mail For Approval?";
        this.$refs["addPopMail"].open();
      }
      if (id == "2") {
        this.alert.content = "Are you sure you want to Approve?";
        this.$refs["addPopApprove"].open();
      }
      if (id == "3") {
        this.alert.content = "Are you sure you want to Reject?";
        this.$refs["addPopReject"].open();
      }
      if (id == "4") {
        this.alert.content = "Are you sure you want to delete this Execution ?";
        this.$refs["addPopDelete"].open();
      }
    },
    showDocModal(item) {
      this.ALLMODULE = "";
      this.JOBSERIES = "";
      this.ALLMODULE = item.allModuleId;
      this.JOBSERIES = item.mainSalesSeries;
      console.log(this.ALLMODULE);
      this.$refs["doc-modal"].show();
    },
    hideDocModal() {
      this.$refs["doc-modal"].hide();
    },
    gotoDocs(item) {
      this.$router.push({
        path: "/allModule/docs/" + item,
      });
    },
    onCloseAction(type) {
      if (type != "cancel") {
        this.isLoading = true;
        let payload = {
          allModuleId: this.mailallModuleId,
          salesExecutionNo: this.mailExecSeries,
          eventId: this.eventId,
        };
        console.log(payload);

        let options = {
          method: "POST",
          url: `${URL_BASE}/Enquiry/salesDeleteActions.php`,
          data: JSON.stringify(payload),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };
        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            if (status == 200 && data) {
              this.getData("0", "0", "1", "1");
              this.isLoading = false;
            }
          })
          .catch((error) => {});
      }
    },

    getData() {
      this.isLoading = true;
      let payload = {
        assignmentNo: "ViewDeleteAssignmentRequestDet",
      };
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Common/getDeleteRequestAssignmentDetails.php`,
        data: JSON.stringify(payload),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };
      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            // console.log(data);
            this.Total_Delete_RequestList = data.DeleteAssignmentRequestData;
            this.totalRows = data.DeleteAssignmentRequestData.length;
          }
          this.isLoading = false;
        })
        .catch((error) => {});
    },
  },
};
</script>

<style>
.md-direction-bottom-right {
  width: 30% !important;
}
.mrgtop-2per {
  margin-top: 1%;
}
.mrgtop-5px {
  margin-top: 0px;
}
.center {
  text-align: center;
}
.heght-1px {
  height: 1px;
}

.b-form-input-container {
  margin: 4px 0 12px !important;
}
.md-button-color {
  background-color: #607d8d !important;
}

.md-button-color-toggle {
  background-color: rgba(153, 153, 153, 0.4) !important;
}

.activeClass {
  display: none;
}
.error {
  color: red;
}
.navbar-brand {
  height: auto;
}
@media only screen and (min-width: 320px) and (max-width: 766px) {
  .mobile-btn {
    margin-right: 13px;
  }
  .navbar-dark .navbar-brand.mobile-font {
    font-size: 15px !important;
  }
}
</style>



// WEBPACK FOOTER //
// viewDeleteRequestAllModuleDetails.vue?4fe4056c